// @module C3.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.PDP.KitUpItems.Collection'
,	[
	   'Item.Collection'	
    ]
, function (
	ItemCollection
)
{
    'use strict';

	// @class C3.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return ItemCollection.extend({
    initialize: function(options) {
       // this.searchApiMasterOptions = Configuration.searchApiMasterOptions.correlatedItems;
       this.searchApiMasterOptions= {
        fieldset : 'details'
       }
       // console.log(options)
        /*this.itemsIds = _.isArray(options.itemsIds)
            ? _.sortBy(options.itemsIds, function(id) {
                  return id;
              })
            : [options.itemsIds];
        this.responseResults =  _.isArray(options.responseResults)
            ? _.sortBy(options.responseResults, function(id) {
                  return id;
              })
            : [options.responseResults];*/  
        this.itemsIds = options.itemsIds;
        this.parentItemInfo = options.parentItemInfo;
        this.responseResults = options.responseResults; 
    },

    // @method fetchItems @return {jQuery.Deferred}
    fetchItems: function() {
        //console.log(this.itemsIds)
        return this.fetch({ data: { id: this.itemsIds.join(',') } });
    },

    // http://backbonejs.org/#Model-parse
    parse: function(response) {
        const original_items = _.compact(response.items) || [];
        const self = this;
        var items = [];

        var selector_data = []
         _.each(this.itemsIds, function(ids) {

            selector_data = _.find(original_items, function(obj) {
                return obj.internalid == ids;
            });
            if(selector_data)
            {
                var applyStrikeThroughPrice = false
                ,   special_formatted_pricelevel1 = ''
                ,   special_formatted_pricelevel5 = ''
                ,   qtyAvailableInv = selector_data.custitem_qty_available_inv
                ,   qtyAvailableKit = selector_data.custitem_qty_available_kit
                ,   itemType = selector_data.itemtype
                ,   enableOutOfStock = selector_data.custitem_celigo_shopify_enable_out_sto
                ,   isWebsiteCategoryProduct = selector_data.custitem157 
                ,   isKitItemOnly = selector_data.custitem_kit_item_only
                ,   price_detail = selector_data.onlinecustomerprice_detail
                ,   showOutofStock = false
                ,   ItemPrice = '' ;

                if(qtyAvailableInv == undefined)
                    qtyAvailableInv = 0;

                if(qtyAvailableKit == undefined)
                    qtyAvailableKit = 0;

                if(itemType == "Kit")
                {
                    //Item Qty is 0 and Allow out of stock checkbox is not checked
                    if(qtyAvailableKit <= 0 && enableOutOfStock == false)
                        showOutofStock = true; 
                }
                else if(itemType == 'InvtPart' || itemType == 'Assembly')
                {
                    //Item Qty is 0 and Allow out of stock checkbox is not checked
                    if(qtyAvailableInv <= 0 && enableOutOfStock == false)
                        showOutofStock = true;
                }
                if(price_detail)
                {
                    var pricelevel1 = selector_data.pricelevel1
                    ,   pricelevel5 = price_detail.onlinecustomerprice;
                    
                    var currPrice = pricelevel5 || pricelevel1 || 0; 
                    if( currPrice < 5)
                    {
                        showOutofStock = true;
                    }
                 }
                 //console.log('showOutofStock'+showOutofStock)

                 if(!showOutofStock)
                    items.push(selector_data);
            }
          //  debugger;
        });
         
        var final_items = _.compact(items);

        return _.toArray(final_items);  

        }
	});
});
